import React from 'react';
import styled from 'styled-components';

import { MAX_MAPWIDTH_HEIGHT_RATIO } from '../WorldMapConstants';

import { PropTypes } from 'prop-types';

const TooNarrowMessage = styled.div`
   margin-top: 20px;
`;
TooNarrowMessage.displayName = 'TooNarrowMessage';

const WorldmapFrame = styled.div`
   position: relative;
   margin: auto;
   width: ${(props) => props.width}px;
`;
WorldmapFrame.displayName = 'WorldmapFrame';

function PanelSizeManager({ width, children }) {
   const MAX_MAPWIDTH = MAX_MAPWIDTH_HEIGHT_RATIO * window.innerHeight;
   const mapWidth = width >= MAX_MAPWIDTH ? Math.floor(MAX_MAPWIDTH) : width;

   return width < 768 ? (
      <TooNarrowMessage>Please enlarge the window to see the ingests and playouts in the world map</TooNarrowMessage>
   ) : (
      <WorldmapFrame width={mapWidth}>{children(mapWidth)}</WorldmapFrame>
   );
}

PanelSizeManager.propTypes = {
   initiated: PropTypes.bool,
   top: PropTypes.number,
   right: PropTypes.number,
   bottom: PropTypes.number,
   left: PropTypes.number,
   width: PropTypes.number,
   height: PropTypes.number,
   children: PropTypes.any,
};

export default PanelSizeManager;
